<template>
  <div class="livebroadcastdetail">
    <div class="image-box">


      <div class="Notstarted-box" v-if="win.id==2">
        <img src="https://ss3.bdstatic.com/70cFv8Sh_Q1YnxGkpoWK1HF6hhy/it/u=1248397178,615012085&fm=26&gp=0.jpg"/>
        <div class="Notstarted" v-if="win.id=='2'">
          … 直播未开始，敬请期待 …
        </div><!--未开始时候的提示框-->
      </div>


      <div class="live-box" v-if="win.id=='1'||win.id=='0'">
          <Plyvideo v-if="Livestreaming!=''" :Livestreaming="Livestreaming.playHlsUrl" :type="win.type" style="width:100%;height:100%" />
          <Plyvideo v-if="win.id=='0'" :Livestreaming="win.src" :type="win.type"/>
          <!-- <div class="LiveplaybackItem-top-live-title" v-if="win.id=='1'||win.id=='0'">
            <li><i class="iconfont icon-zhibozhong"></i>{{win.id=="0"?"重播":"直播中"}}</li><li>{{this.mans?mans:win.viewers}}{{win.id=="0"?"人已观看":"人正在观看"}}</li>
          </div> -->
          <!--这个是当为正在直播的时候显示-->
      </div>


    </div>
    <div class="nav">
        <li><span :class="Selectedvalue==0?'selectspan':'defaultspan'" @click="clickNavigation">直播简介</span></li>
        <li><span :class="Selectedvalue==1?'selectspan':'defaultspan'" @click="clickNavigation">评论互动</span></li>
    </div>
    <div class="nav-content-box">
      <div class="nav-content">
        <div class="Liveintroduction-box" v-if="Selectedvalue==0">
          <li><span>开始时间:</span><h3>{{win.detaillist.startTime}}</h3></li>
          <li><span>结束时间:</span><h3>{{win.detaillist.endTime}}</h3></li>
          <li><span>讲师:</span><h3>{{win.detaillist.lecturer}}</h3></li>
        </div>



        <div class="Commentinteraction-box" v-if="Selectedvalue==1">
            <div class="Commentinteraction-box-content" v-if="win.id=='1'||win.id=='0'" :style="{height:win.id=='0'?'100%':'',overflow:win.id=='0'?'auto':''}" loading-text="132">
                <van-pull-refresh v-model="refreshing" @refresh="onRefresh" v-if="win.id=='0'">
                    <span v-for="(item,index) in commentlist" :key="index"><i>{{item.name}}：</i>{{item.val}}</span>
                    <div style="color:#ccc;textAlign:center;width:100%;height:100%;lineHeight:300px" v-if="commentlist.length<=0">暂无评论</div>
                </van-pull-refresh>
                <div v-if="win.id=='1'">
                  <span v-for="(item,index) in commentlist" :key="index"><i>{{item.name}}：</i>{{item.val}}</span>
                </div>
            </div>


            <div class="publish-box" v-if="win.id=='1'">
              <input v-model="value" placeholder="说说您的想法吧...." @focus="focus"/><button @click="sendout">发送</button>
            </div>
            <div class="LiveNotstarted-box" v-if="win.id=='2'">
            —— 直播未开始，暂不能评论 ——
            </div>
        </div>
        
      </div>
    </div>
  </div>
</template>

<script>
import Plyvideo from "../components/Homecomponents/Playvideo"
import {Getlivevideo,getReplaycomments} from "../api/index"
import {Toast} from "vant"
export default {
  data(){
    return{
      win:sessionStorage.LiveBroadcastDeail?JSON.parse(sessionStorage.LiveBroadcastDeail):"",
      Selectedvalue:0,//判断是直播简介还是评论互动
      value:"",//评论输入的value值
      commentlist:[{name:"健康小课堂",val:"欢迎来到直播间！本平台禁止出现违法违规、色情低俗、抽烟喝酒、诱导欺诈等行为。感谢您的参与！"}],//存放用户的评论信息
      Livestreaming:"",//直播流
      ws:"",
      mans:"",//观看人数
      type:"application/x-mpegURL",//播放类型
      refreshing: false,//每次加载评论列表是否显示loading
      size:20,
      ifsend:false,//判断是否可以发消息,
      iflink:false,//判断是否重新链接
    }
  },
  created(){
    if(this.win.id=="1")
    {
      this.Selectedvalue=1
    }else if(this.win.id=="2")
    {
      this.Selectedvalue=0
    }else{
      this.Selectedvalue=0
    }
  },
  mounted(){
    console.log(this.win.id)
    if(this.win.id=="1")
    {
    this.Livestreaming=""
    this.Getlivevideolist()
    this.Linkbackground()
    }else if(this.win.id=="0"){
      this.getReplaycommentslist({current:1,size:this.size,tvideoId:this.win.videoId})
    }
    
  },
  methods:{
    focus(){
      let u = navigator.userAgent;
      let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      if (isiOS) {
        window.scrollTo(0, 0);
      }
    },
    onRefresh() {//每次下拉评论列表的时候执行
      setTimeout(()=>{
        this.refreshing=false
        this.size+=20
        this.getReplaycommentslist({current:1,size:this.size,tvideoId:this.win.videoId})
      },1000)
      
    },
    clickNavigation(e){//切换
      switch(e.target.innerHTML)
      {
        case "直播简介":this.Selectedvalue=0;break;
        case "评论互动":this.Selectedvalue=1;break;
      }
    },
     add(){
        setTimeout(() => {
           var div = document.querySelector('.Commentinteraction-box-content');
             div.scrollTop = div.scrollHeight+20;
        }, 1000);
     },
    Linkbackground(){
      let that=this
      if("WebSocket" in window)
      {
            this.ws = new WebSocket("wss://api.live.lejian.com/websocket?streamId"+this.win.liveStreamId);
            //  this.ws = new WebSocket("ws://172.16.10.202:8080/api/websocket?streamId="+this.win.liveStreamId);

               let timer=setInterval(()=>{
                 this.ws.send("viewers-request")
               },5000)
               this.ws.onopen = function()
               {
                  // Web Socket 已连接上，使用 send() 方法发送数据
                  that.ifsend=true
                  that.iflink=true
                  Toast("链接评论服务器成功")
                   that.ws.send("")
                 
               };
               let setMessageInnerHTML=function(data){ 
                 let newobj={name:data.slice(0,data.indexOf("|")),val:data.slice(data.indexOf("|")+3)}
                 that.commentlist.push(newobj)
                 that.add()
               } 
      
               this.ws.onmessage = function (evt) 
               { 
                
                 if(evt.data.includes("viewers-response:"))
                 {
                   var index=evt.data.lastIndexOf(":");
                   that.mans=evt.data.slice(index+1)

                 }else{setMessageInnerHTML(evt.data)}
                  
               };
                
               that.ws.onclose = function()
               { 
                 that.ifsend=false
                 clearInterval(timer)
               };    
                          
      }
      setTimeout(() => {
        if(this.iflink==false){
          this.Linkbackground()
        }
      }, 1000);

    },
    async Getlivevideolist(){
      let data=await Getlivevideo(this.win.hubId)
      this.Livestreaming=data.data.data
    },
    sendout(){
        if(this.value=="")
        {
          // this.$notify({ type: 'warning', message: '输入内容不能为空' });
          Toast("不能发送空白的评论哦",5)
        }else{
          let newsenddata=this.win.liveStreamId+"|-|"+this.value+"|-|"+sessionStorage.name
          //  let newsenddata=this.win.liveStreamId+"|-|"+this.value+"|-|"+"556"
          if(this.ifsend){
            this.ws.send(newsenddata)
            this.add()
          }else{
            Toast("当前链接不稳定,请重新进入",5)
          }
          
          this.value=""//每次点击完评论按钮后清空输入框
        }
       
    },
    async getReplaycommentslist(obj){//获取回放里的评论列表
      this.commentlist=[]
      let data=await getReplaycomments(obj)
      let newcommentlist=[]
      data.data.data.records.forEach((item)=>{
        newcommentlist.unshift({name:item.userName,val:item.reviewText})
      })
      this.commentlist=newcommentlist
    }
  },
  components:{
    Plyvideo
  },
  beforeDestroy () {
    if(this.win.id=="1"){
       this.ws.close()//关闭websocket链接
    }
   
  }
}
</script>

<style lang="scss">

.livebroadcastdetail{
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  
  .image-box{
    width: 100%;
    height:206.7px;
    min-height: 206.7px;;
    position: relative;
    background: black;
    overflow: auto;
    .Notstarted-box{
      width: 100%;
      height: 100%;
      img{
          width: 100%;
          height: 100%;
        }
    .Notstarted{
          width: 100%;
          height:50px;
          position: absolute;
          background:rgba(0,0,0,0.3);
          left: 0;
          top: 0;
          right: 0;
          bottom: 0;
          margin: auto;
          text-align: center;
          line-height: 50px;
          color: white;
        }
    }
    .live-box{
      width: 100%;
      height: 100%;
      position: relative;
      .LiveplaybackItem-top-live-title{
          width: 100%;
          height: 40px;
          position: absolute;
          top: 0;
          left: 0;
          padding-top: 10px;
          li:nth-child(1){
            width: 66px;
            height: 20px;
            background: #E94709;
            color: white;
            float: left;
            font-style: normal;
            text-align: center;
            line-height: 21px;
            font-size:11px;
            transform:scale(1);
          }
          li:nth-child(1) i:nth-child(1){
           font-size: 11px;
          }
          li:nth-child(2){
            height: 20px;
            background:rgba(0,0,0,0.5);
            color: white;
            float: left;
            font-style: normal;
            text-align: center;
            line-height: 21px;
            transform:scale(1);
            padding-left: 10px;
            padding-right: 10px;
          }
      }
    }
    
  }
  .nav{//导航栏样式
    width: 100%;
    height: 60px;
    min-height: 60px;
    display: flex;
    border-bottom: 1px solid rgb(233, 231, 231);
    margin: 0px auto;
    li{
      flex: 1;
      text-align: center;
      line-height: 60px;
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
      .defaultspan{
        display: inline-block;
        width: 85px;
        height: 100%;
        font-size: 16px;
        position: absolute;
        bottom: -1px;
      }
      .selectspan{
        display: inline-block;
        width: 85px;
        height: 100%;
        border-bottom: 3px solid #E94709;
        font-size: 18px;
        font-weight: bold;
        position: absolute;
        bottom: -1px;
      }
    }
  }
  .nav-content-box{
    width: 100%;
    height: 60%;
    overflow: auto;
    .nav-content{
      width: 100%;
      height: 100%;
      .Liveintroduction-box{
        width: 100%;
        padding-top: 15px;
        padding-left: 20px;
        display: flex;
        flex-direction: column;
        li{
          width: 100%;
          height: 20px;
          margin: 10px auto;
          line-height: 20px;
          span{
            display: block;
            float: left;
            color: #666666;
            font-size: 14px;
            margin-right: 10px;
          }
          h3{

            float: left;
            font-size: 14px;
            font-weight: 500;
          }
        }
      }

      .Commentinteraction-box{
        width: 100%;
        height: 100%;
        background: #F4F4F4;
        overflow-y: hidden;
        -webkit-overflow-scrolling: touch;
       .LiveNotstarted-box{
          width: 100%;
          height: 100%;
          text-align: center;
          line-height: 410px;
          box-sizing: border-box;
          background: white;
        }
        .Commentinteraction-box-content{
          width: 100%;
          height: 89%;
          display: flex;
          flex-direction: column;
          padding-top: 15px;
          padding-left: 20px;
          padding-right: 20px;
          background: white;
          word-wrap:break-word;
          overflow: auto;
         .van-loading__text{
              text-align: center !important;
              display: block;
              height: 30px;
              line-height: 15px;
          }
          ::-webkit-scrollbar{ // 直接复制黏贴到样式页.css，完美解决
            display: none ;
            /* background-color:transparent; */
          }
          span{
            display: block;
            width: 100%;
            font-size: 14px;
            margin:10px auto;
            text-align: left;
            word-wrap:break-word;
            line-height: 25px;
            i{
              display: block;
              height: 16px;
              float: left;
              color: #FF000F;
              font-style: normal;
              // display: block;
            }
          }
          .van-pull-refresh{
            overflow: auto;
            height: 100%;
            width: 100%;
          }
        }
       
      .publish-box{
        height: 60px;
        min-height: 60px;
        padding-left: 15px;
        padding-top: 5px;
        input{
          width: 280px;
          height: 30px;
          border: none;
          border-radius: 5px;
          padding-left: 10px;
        }
        button{
          margin-left: 10px;
          width: 55px;
          height: 30px;
          background: #E94709;
          color: white;
          border: none;
          border-radius: 5px;
        }
      }
      }
      
    }
  }
  .vjs-big-play-button{
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    margin: auto;
  }
}
</style>